/**
 * WABA Analytics page APIs.
 */
import { apihubPost } from "./apihub";

export function fetchMessageAnalytics(projectId, startsunix, endunix) {
  return apihubPost("/getInteractedCustomerDetail/fetchanalytics", {
    projectid: projectId,
    startsunix,
    endunix,
  });
}

export function fetchPricingAnalytics(projectId, startsunix, endunix) {
  return apihubPost("/getInteractedCustomerDetail/fetchpricinganalytics", {
    projectid: projectId,
    startsunix,
    endunix,
  });
}
